export default "__VITE_ASSET__DRyXPQjr__"